import utc from "dayjs/plugin/utc";
import dayjs, { Dayjs } from "dayjs";
dayjs.extend(utc);

export const handleDataForLogin = (
  userData: any,
  refreshToken: string,
  accessToken: string
) => {
  localStorage.setItem("user-info", JSON.stringify(userData));
  localStorage.setItem("refresh-token", refreshToken);
  handleDataForRefreshToken(accessToken);
};

export const handleDataForRefreshToken = (accessToken: string) => {
  localStorage.setItem("access-token", accessToken);
};

export const handleDataForLogout = () => {
  localStorage.removeItem("user-info");
  localStorage.removeItem("refresh-token");
  localStorage.removeItem("access-token");
};

export const currencyFormat = (
  value: number | string = 0,
  currency: string = "VND"
) => {
  let currencyValue;

  if (typeof value === "number") {
    currencyValue = value;
  } else {
    currencyValue = parseFloat(value);
  }
  return currencyValue.toLocaleString("en-US", {
    style: "currency",
    currency: currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const convertISOtoLocalTime = (ISOTime: string = "") => {
  const localeTime = new Date(ISOTime);
  return `${localeTime.getDate()}/${
    localeTime.getMonth() + 1
  }/${localeTime.getFullYear()}`;
};

export const getDateFromTimeString = (timeString: string = "") => {
  const time = new Date(timeString);
  const date = time.getDate();
  const weekDate = time.toLocaleDateString("en-US", {
    weekday: "long",
  });
  const monthYear = time.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
  return {
    date,
    weekDate,
    monthYear,
  };
};

export const convertLocaltoISOTime = (localTime: string = "") => {
  const ISOTime = new Date(localTime).toISOString() || "";
  return ISOTime;
};

export const convertCurrencyStringToNumber = (
  currencyStr: string | null | undefined
) => {
  if (currencyStr) {
    return parseFloat(currencyStr.replace(/,/g, ""));
  }
};

export const getCurrentWeek = () => {
  const toDay = new Date();
  const currentYear = toDay.getFullYear();
  const currentMonth = toDay.getMonth() + 1;
  const currentWeek = Math.ceil(toDay.getDate() / 7);
  return {
    currentYear,
    currentMonth,
    currentWeek,
  };
};

export const getMonthFromToDay = () => {
  const { currentYear, currentMonth } = getCurrentWeek();
  const months = [];
  for (let year = 2021; year <= currentYear; year++) {
    if (year === currentYear) {
      for (let month = 1; month <= currentMonth; month++) {
        months.push({
          year,
          month,
        });
      }
    } else {
      for (let month = 1; month <= 12; month++) {
        months.push({
          year,
          month,
        });
      }
    }
  }
  return months;
};

export const isObjectEmpty = (obj: Object) => {
  return !Object.keys(obj).length;
};

export const getChangedValues = <
  O1 extends { [key: string]: any },
  O2 extends { [key: string]: any }
>(
  initObj: O1,
  newObj: O2
): any => {
  let changedValues: any = {};
  Object.keys(initObj).forEach((key) => {
    if (initObj[key] !== newObj[key]) {
      changedValues[key] = newObj[key];
    }
  });

  return changedValues;
};

export const convertDayjsUTCtoBackendUTC = (timeString: Dayjs) => {
  console.log("timestring:", timeString);
  if (timeString) {
    const utcString = timeString
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss")
      .split("Z")[0];
    return `${utcString}.000Z`;
  }
};

export const handleCancelForm = (formRef: any, CancelFn: Function) => {
  if (formRef?.current?.dirty) {
    const isCancel = window.confirm(
      "You have unsaved changes! You still want to leave the form?"
    );
    if (isCancel) CancelFn();
  } else {
    CancelFn();
  }
};
